import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";
import { QueryParamsEntitiesV3 } from "@/domain/entities/MainApp";

export class SummaryApiRequest {
  period = "";
  scope = "";

  constructor(fields?: Partial<SummaryApiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(ConvertObjectCamelToSnakeCaseV2(this))
      .queryString;
  }
}
